import { Component, Input, ViewChild } from '@angular/core';
import { IonicPage, Slides, NavController, NavParams, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
// import { BarcodeScanner } from '@ionic-native/barcode-scanner';
// import { BrowserQRCodeReader } from '@zxing/library';
import { Camera, CameraOptions } from '@ionic-native/camera';

import { LoginPage } from '../login/login';

// import * as $ from "jquery";

/**
 * Generated class for the ForgotPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-forgot',
    templateUrl: 'forgot.html',
})
export class ForgotPage {
    @ViewChild(Slides) slides: Slides;
    @Input() data: any;
	@Input() events: any;

	qrData = null;
  	createdCode = null;
	scannedCode = null;

    qr_code:string = '';
    
    texts: any = [];
    language : string;
    
    servermode: string;
	
	id: string;
    security: string = '';
    password: string;
    server_name: string;
    version: string;

	private isIdValid: boolean = true;
	private isQr_code: boolean = true;
	// private isKeyValid: boolean = true;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		private alertCtrl: AlertController,
		public toastCtrl: ToastController,
		private camera: Camera,
		public app: App
	) {
		
	}

	ionViewWillEnter() {
	//// 로그인 정보를 지운다.
        localStorage.removeItem("loginId");        

        localStorage.setItem("pageName", "forgot");
        this.servermode = localStorage.getItem("servermode");
        this.server_name = localStorage.getItem("server_name");        
		this.language = localStorage.getItem("language");
		this.version = localStorage.getItem("version");
		this.texts = JSON.parse(localStorage.getItem("texts"));

		this.slides.freeMode = true;		
		this.slides.slideTo(0, 0);
        this.slides.lockSwipes(true);

		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).forgot;
	}
    
    // slideback() {
    //     this.slides.lockSwipes(false);
    //     this.slides.slidePrev();
    //     this.slides.lockSwipes(true);
    // }

	_event = (event: string): void => {
		if (event == "close") {
            this.navCtrl.pop();
        }
        if (event == "login") {
            this.app.getRootNav().setRoot(LoginPage);
        } 
		if (event == "forgot") {
            if (this._validate()) {
			// this.slides.lockSwipes(false);
			// this.slides.slideNext();
			// return this.slides.lockSwipes(true);
					
                let body = JSON.stringify({
                    id: this.id.toLocaleLowerCase(),
                    // security: this.qr_code,
                    language: this.language,
                    version: this.version,
                    security: this.security
                });
                this.http.post("password",body).then((res:any)=>{
                    if(res.result=="OK"){
                        if (this.slides.getActiveIndex() == 0) {
                            this.password = res.password;
                            this.slides.lockSwipes(false);
                            this.slides.slideNext();
                            return this.slides.lockSwipes(true);
                        }
                    } else if(res.result ==="LOGOUT"){
                        let alert = this.alertCtrl.create({
                            message: res.message,
                            buttons: ['OK']
                        });
                        alert.present();
                        localStorage.removeItem("loginId");
                        this.app.getRootNav().setRoot(LoginPage);
                    
                    } else {
                        let alert = this.alertCtrl.create({
                            message: res.message,
                            buttons: ['OK']
                        });
                        alert.present();
                    }
                },(err)=>{
                    let alert = this.alertCtrl.create({
                        message: err.message,
                        buttons: ['OK']
                    });
                    alert.present();
                });
            }
		}
		
	}

    //갤러리를 열고 이미지를 base64로 인코딩하여 imagePath에 넣음.
	_upload(){
		const options: CameraOptions = {
			quality: 100,
			//촬영-CAMERA, 갤러리-PHOTOLIBRARY
			sourceType:this.camera.PictureSourceType.PHOTOLIBRARY,
			//URL을 어떤 형식으로 받을지..
			destinationType: this.camera.DestinationType.DATA_URL,
			encodingType: this.camera.EncodingType.JPEG,
			mediaType: this.camera.MediaType.PICTURE,
		  
		}
		
		this.camera.getPicture(options).then((imageData) => {
			let base64Image = 'data:image/jpeg;base64,' + imageData;
			this.qr_code = base64Image;
			// this._decode();
		}, (err) => {
		 	console.log('Error: ', err);
		});	
	}
    
	//imagePath(dataURL / base64)의 URL을 디코딩
	// _decode(){
	// 	const codeReader = new BrowserQRCodeReader()
	// 	codeReader.decodeFromImage(undefined,this.imagePath)
	// 	.then((result) => {
	// 		console.log("success")
	// 		this.security = result.getText();
	// 	}).catch((err) => {
	// 		console.error(err)
	// 	})

	// }//end decode

	_validate():boolean {
		this.isIdValid = true;
		this.isQr_code = true;
		// this.isKeyValid = true;

        if (!this.id || this.id.length == 0) {
            this.isIdValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_id,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;     
        }

        if (!this.qr_code) {
            this.isQr_code = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_qrcode,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }
        
        // if (!this.security || this.security.length == 0) {
        // 	this.isKeyValid = false;
        // 	const toast = this.toastCtrl.create({
        // 		message: this.texts.toastM_security,
        // 		duration: 2000,
        // 		position: 'middle'
        // 	});
        // 	toast.present();
        // 	return ;
        // }

		return this.isIdValid && this.isQr_code;
	}
}



// WEBPACK FOOTER //
// ./src/pages/forgot/forgot.ts